export default __webpack_public_path__ + "static/media/plusIconRestaurant.80f0b992.svg";